import { useEffect } from 'react';
import { Navigate, Outlet, createBrowserRouter, useNavigate } from 'react-router';
import { Shell } from './App';
import { PATHS } from './navigation';
import { setNavigator } from './navigation';
import { Calendar } from './screens/Calendar';
import { Confirm } from './screens/Confirm';
import { Inhalt } from './screens/Inhalt';
import { Notes } from './screens/Notes';
import { Overview } from './screens/Overview';
import { PhoneScanner } from './screens/PhoneScanner';
import { Scan } from './screens/Scan';
import { Settings } from './screens/Settings';
import { Setup } from './screens/Setup';
import { Shopping } from './screens/Shopping';
import { useStore } from './store';

/** Lends the store the router's navigate for the whole app's lifetime. */
function Root() {
  const navigate = useNavigate();
  useEffect(() => {
    setNavigator(navigate);
    return () => setNavigator(null);
  }, [navigate]);
  return <Outlet />;
}

/**
 * The confirm step is reachable by URL but means nothing without a draft —
 * a reload mid-scan lands here with empty hands, so it falls back to the scan
 * screen rather than rendering a blank form.
 */
function RequireDraft() {
  const draft = useStore((s) => s.draft);
  if (!draft) return <Navigate to={PATHS.scan} replace />;
  return <Confirm />;
}

export const router = createBrowserRouter([
  {
    element: <Root />,
    children: [
      // Its own world: a scoped token, no household session, no shell. The
      // token segment is optional because the view scrubs it from the URL once
      // claimed — same route, so the component stays mounted.
      { path: '/s/:token?', element: <PhoneScanner /> },
      {
        element: <Shell />,
        children: [
          { path: PATHS.dash, element: <Overview /> },
          { path: PATHS.inhalt, element: <Inhalt /> },
          { path: PATHS.scan, element: <Scan /> },
          { path: PATHS.confirm, element: <RequireDraft /> },
          { path: PATHS.cal, element: <Calendar /> },
          { path: PATHS.shop, element: <Shopping /> },
          { path: PATHS.notes, element: <Notes /> },
          { path: PATHS.settings, element: <Settings /> },
          { path: PATHS.setup, element: <Setup /> },
        ],
      },
      // A wall panel has no address bar to correct a typo in — anything
      // unknown goes home rather than showing a dead end.
      { path: '*', element: <Navigate to={PATHS.dash} replace /> },
    ],
  },
]);
